@let badges = this.badges();

@if (badges) {
    @for (badge of badges; track badge) {
        <div class="row">
            <div [class]="badgeMap.get(badge)?.label">
                {{ badgeMap.get(badge)?.translationKey ?? '' | translate }}
            </div>
        </div>
    }
}
